import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLink from '../../../library/form/components/FormLink';
import SarasRowSelector from "../../../library/hooks/selector/SarasRowSelector";
import FormWrapper from '../../../library/form/components/FormWrapper';

const InvImportItemsRow = (props) => {
    const { formObject, rowKey, rowSelector } = props

    return (
        <li>
            <ul>
                <li className='uiColumnCenter uiColumn50'>
                    <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "itemSelect" }} >
                        <SarasRowSelector rowSelector={rowSelector} rowID={rowKey}
                            useCheckBox={true} />
                    </FormWrapper>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemType" }} />
                </li>
                <li className="uiColumnCenter uiColumn70"  >
                    <FormLink formObject={formObject} rowKey={rowKey}
                        action={{
                            paramName: "itemId",
                            actionId: "show", 
                            containerKey: "popup"
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter " style={{width:"150px"}}>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    {/* <FormInput formObject={formObject} className="uiInput uiVal40" rowKey={rowKey}
                        action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom1" }} /> */}
                    {/* <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemQty2Container" }} > */}
                        {/* <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiVal40" 
                            action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom2" }} /> */}
                    {/* </FormWrapper> */}
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemQty" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} />
                </li>
                <FormWrapper customWrapper="li" wrapperClass="uiColumnCenter uiColumn100" 
                    formObject={formObject} rowKey={rowKey} action={{ paramName: "itemAmount" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemAmount" }} />
                </FormWrapper>
            </ul>
        </li>
    )
}

export default InvImportItemsRow